import React from "react";
import Paper from "@mui/material/Paper";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import { useForm } from "@/src/provider/Form/FormProvider";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type PersonalTextMessageProps = {
  submitProps: FormSubmitProps;
};

export default function PersonalTextMessage({ submitProps }: PersonalTextMessageProps) {
  const { handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Mein Anliegen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>Bitte schildern Sie hier kurz Ihr Anliegen, damit wir Sie bestmöglich beraten können.</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField
                name="personalTextMessage"
                label="Ihr Anliegen"
                placeholder="Schildern Sie hier kurz Ihr Anliegen"
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                rows={10}
                validators={[requiredValidator("Bitte schildern Sie uns hier kurz Ihr Anliegen.")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
